<template>
  <!-- Coluna de opções do Dashboard -->
  <el-row :gutter="20">
    <el-col :xs="24" :sm="7">
      <el-date-picker
        v-model="dateRangeInternal"
        type="daterange"
        align="left"
        :unlink-panels="false"
        range-separator="-"
        start-placeholder="Data inicial"
        end-placeholder="Data final"
        format="dd/MM/yyyy"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        :picker-options="pickerDateOptions"
      >
      </el-date-picker>
    </el-col>

    <el-col :xs="24" :sm="7" style="padding-left: 20px;">
      <el-select
        v-model="usersSelectedInternal"
        multiple
        filterable
        collapse-tags
        placeholder="Filtrar por usuário"
      >
        <el-option
          v-for="item in allDrivers"
          :key="item.login"
          :label="item.name"
          :value="item.auth_uid"
        >
        </el-option>
      </el-select>
    </el-col>

    <el-col :xs="24" :sm="6">
      <el-button-group>
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          @click="searchClick"
          >Pesquisar</el-button
        >
        <el-button
          v-if="!isListening"
          type="primary"
          icon="el-icon-refresh"
          plain
          @click="refreshClick"
          >Automático</el-button
        >
        <el-button
          v-if="isListening"
          type="primary"
          icon="el-icon-loading"
          plain
          @click="stopClick"
          >Parar</el-button
        >
      </el-button-group>
    </el-col>
  </el-row>
</template>

<script>
import { mapState } from 'vuex'
import dates from '@/helpers/getDateRange'

export default {
  name: 'filterBar',
  props: {},
  data() {
    return {
      pickerDateOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '1 dia',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '7 dias',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '30 dias',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      usersSelectedInternal: [],
      dateRangeInternal: [dates.d.startDateTodayFull, dates.d.endDateFull],
      isListening: false,
    }
  },
  computed: {
    ...mapState('Drivers', ['allDrivers']),
    formatedUserSelect() {
      return this.usersSelectedInternal.length > 0
        ? this.usersSelectedInternal
        : ['*']
    },
  },
  methods: {
    async searchClick() {
      this.$emit('searchClick', {
        usersFilter: this.formatedUserSelect,
        startDateFilter: this.dateRangeInternal[0],
        endDateFilter: this.dateRangeInternal[1],
      })
    },
    async refreshClick() {
      this.isListening = true
      this.$emit('refreshClick', {
        usersFilter: this.formatedUserSelect,
        startDateFilter: this.dateRangeInternal[0],
        endDateFilter: this.dateRangeInternal[1],
      })
    },
    async stopClick() {
      this.isListening = false
      this.$emit('stopClick')
    },
  },
}
</script>
